import "./TeamTotals.css";

// Fixed set of comparison boxes — independent of the user's column selection. Locked order.
// Shooting boxes (FG/FT/3PT) show the percentage from raw makes/attempts; counting boxes show totals.
const BOXES = [
  { key: "pts", label: "PTS", kind: "count", better: "high" },
  { key: "ft", label: "FT", kind: "shoot", m: "ftm", a: "fta", better: "high" },
  { key: "fg", label: "FG", kind: "shoot", m: "fgm", a: "fga", better: "high" },
  { key: "fg3", label: "3PT", kind: "shoot", m: "fg3m", a: "fg3a", better: "high" },
  { key: "reb", label: "REB", kind: "count", better: "high" },
  { key: "ast", label: "AST", kind: "count", better: "high" },
  { key: "tov", label: "TO", kind: "count", better: "low" },
  { key: "stl", label: "STL", kind: "count", better: "high" },
  { key: "blk", label: "BLK", kind: "count", better: "high" },
];

const liveSum = (rows, stat) => rows.reduce((a, r) => a + (Number.isInteger(r.live?.[stat]) ? r.live[stat] : 0), 0);
const liveSumN = (rows, stat) => { let any = false; const t = rows.reduce((a, r) => { const v = r.live?.[stat]; if (Number.isInteger(v)) { any = true; return a + v; } return a; }, 0); return any ? t : null; };
const projSum = (rows, stat) => { let any = false; const t = rows.reduce((a, r) => { const p = r.stats?.[stat]?.proj; if (p != null) { any = true; return a + p; } return a; }, 0); return any ? t : null; };

// Returns {value, display, shots} for a box. value = comparable number (total or pct) or null.
function boxData(rows, box, espn) {
  if (box.kind === "shoot") {
    if (!espn) return { value: null, display: "—", shots: null };
    const made = liveSum(rows, box.m), att = liveSum(rows, box.a);
    if (att <= 0) return { value: null, display: "—", shots: null };
    const pct = (100 * made) / att;
    return { value: pct, display: `${Math.round(pct)}%`, shots: `${made}/${att} - ${Math.round(pct)}%` };
  }
  const v = espn ? liveSumN(rows, box.key) : projSum(rows, box.key);
  if (v == null) return { value: null, display: "—", shots: null };
  const display = Number.isInteger(v) ? String(v) : (Math.round(v * 10) / 10).toFixed(1);
  return { value: v, display, shots: null };
}

function compareState(a, b, better) {
  if (a == null || b == null) return "tie";
  if (Math.abs(a - b) < 1e-8) return "tie";
  return (better === "high" ? a > b : a < b) ? "win" : "lose";
}

export function TeamTotalsCompare({ teams, scope }) {
  const espn = scope === "espn";
  if (!teams.length) return null;
  const pair = teams.length === 2;
  const data = teams.map((t) => BOXES.map((b) => boxData(t.rows, b, espn)));
  return (
    <section className="nbc-totals" aria-label="Team totals comparison" data-testid="arena-totals-compare">
      {teams.map((t, i) => (
        <div className="nbc-team" key={t.code} data-testid={`arena-total-card-${t.code}`}>
          <div className="nbc-team-identity">
            {t.logo && <img src={t.logo} alt="" loading="lazy" />}
            <div><strong>{t.code}</strong><em>{t.home ? "HOME" : "AWAY"}</em></div>
          </div>
          <div className="nbc-metrics-scroll">
            <div className="nbc-metrics">
              {BOXES.map((b, j) => {
                const mine = data[i][j];
                const other = data[pair ? 1 - i : i][j];
                const st = pair ? compareState(mine.value, other.value, b.better) : "tie";
                const tip = mine.shots ? mine.shots : `${b.label}: ${mine.display}`;
                return (
                  <div className={`nbc-metric nbc-${st}`} key={b.key} title={tip} data-testid={`arena-total-${b.key}-${t.code}`}>
                    <div className="nbc-metric-name">{b.label}</div>
                    <strong>{mine.display}</strong>
                    <span className="nbc-meter" aria-label={st === "win" ? "Better" : st === "lose" ? "Worse" : "Tied / neutral"} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
      <div className="nbc-legend">
        <span><i className="nbc-dot green" />Καλύτερη</span>
        <span><i className="nbc-dot red" />Χαμηλότερη</span>
        <span><i className="nbc-dot blue" />Ισοπαλία / ουδέτερο</span>
      </div>
    </section>
  );
}
